/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import { colors } from '../../config/theme';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  field: {
    width: '35%',
    marginRight: '20px',
    marginBottom: '30px',
  },
  resetPassword: {
    width: '165px',
    marginRight: '20px',
    marginBottom: '90px',
    '& div': {
      paddingTop: '10px',
      color: colors.mineShaft,
      border: '1px solid #959595'
    }
  },
  resetPasswordText: {
    width: '100%',
    marginRight: '20px',
    marginBottom: '10px'
  },
  notificationText: {
    marginRight: '20px',
    marginBottom: '10px'
  },
  radioField: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '20px',
    marginBottom: '10px',
    '& label': {
      marginBottom: '0px',
      fontFamily: 'GTAR'
    }
  },
  radioInput: {
    marginRight: '10px !important'
  },
  btn: {
    padding: '7px 15px 9px',
    backgroundColor: 'white',
    border: '1px solid',
    color: '#959595',
    fontSize: '16px',
    fontWeight: 500,
    height: '40px',
    marginRight: '16px',
    cursor: 'pointer'
  },
  privacyBlock: {
    fontFamily: 'GTAR',
    fontSize: '14px',
    lineHeight: 1.43,
    width: '100%',
    height: '356px',
    color: colors.mineShaft,
    padding: '16px 4px 4px 16px',
    borderRadius: '4px',
    border: `solid 1px ${colors.lightGray}`,
    overflow: 'auto'
  },
  submit: {
    backgroundColor: 'black',
    color: 'white'
  },
  listStyle: {
    marginLeft: '50px',
    '& li': {
      listStyle: 'initial !important'
    }
  },
  borderRight: {
    '& td': {
      borderRight: '1px solid #ddd !important'
    },
    '& th': {
      borderRight: '1px solid #ddd !important'
    },
    '& tr': {
      borderBottom: '1px solid #ddd !important'
    }
  },
  borderBottom: {
    height: '2px',
    width: '100%',
    borderBottom: '1px solid #ddd',
    marginBottom: '20px'
  },
  footer: {
    fontSize: '12px',
    color: '#959595',
    marginTop: '24px',
    borderTop: 'solid 1px #eeeeee',
    textAlign: 'right',
    paddingTop: '20px',
    paddingRight: '56px'
  },
  phoneField: {
    '& .form-control': {
      paddingLeft: 0,
      border: 'none',
      borderBottom: `solid 1px ${colors.lightGray}`,
      borderRadius: 'unset',
      width: '100%',
      fontFamily: 'GTAR',
      '&:focus': {
        boxShadow: 'none',
        background: 'unset'
      }
    },
    '& .flag-dropdown': {
      display: 'none'
    }
  },
  calendar: {
    '& .react-datepicker__month-container': {
      '& .react-datepicker__header': {
        '& .react-datepicker__current-month': {
          fontSize: '12px'
        },
        '& .react-datepicker__header__dropdown': {
          padding: '8px 0px 5px',
          '& .react-datepicker__year-dropdown-container': {
            fontSize: '12px'
          }
        },
        '& .react-datepicker__day-names': {
          '& .react-datepicker__day-name': {
            width: '35px',
            lineHeight: '20px',
            fontSize: '12px'
          }
        }
      },
      '& .react-datepicker__month': {
        '& .react-datepicker__week': {
          '& .react-datepicker__day': {
            width: '35px',
            lineHeight: '25px',
            fontSize: '12px'
          }
        }
      }
    }
  },
  margin5: {
    marginBottom: '12px'
  },
  '@media only screen and (max-width:979px)': {
    field: {
      width: '47%'
    },
    margin5: {
      '& label': {
        marginBottom: '0px'
      }
    }
  },
  '@media only screen and (max-width:1250px)': {
    margin5: {
      '& label': {
        marginBottom: '0px'
      }
    }
  }
});

export default useStyles;
